import { createElement } from 'react';
import { node, object } from 'prop-types';
import '../types/props.js';
import { withTheme } from 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import _get from 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends, a as _objectSpread } from '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import 'reakit/Portal';
import '../Portal/styled.js';
import '../Portal/index.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import '../Button/index.js';
import '../Icon/index.js';
import '../VisuallyHidden.js';
import 'reakit/Backdrop';
import '../Backdrop/styled.js';
import '../Backdrop/index.js';
import '../chunk-5c9bbccf.js';
import 'focus-trap';
import '../chunk-abb87050.js';
import '../Container/styled.js';
import { b as containerPropTypes, c as containerDefaultProps } from '../chunk-cfb51aee.js';
import '../Container/index.js';
import 'reakit/Sidebar';
import '../Sidebar/SidebarContainer.js';
import '../Sidebar/styled.js';
import '../Sidebar/SidebarClose.js';
import '../Sidebar/SidebarHide.js';
import '../Sidebar/SidebarShow.js';
import '../chunk-3ccbd0d4.js';
import '../Sidebar/index.js';
import { PageContentWrapper, PageContent as PageContent$1 } from './styled.js';

var PageContent = function PageContent(_ref) {
  var breakpoint = _ref.breakpoint,
      children = _ref.children,
      isFluid = _ref.isFluid,
      isLayout = _ref.isLayout,
      theme = _ref.theme,
      wrapperProps = _ref.wrapperProps,
      props = _objectWithoutPropertiesLoose(_ref, ["breakpoint", "children", "isFluid", "isLayout", "theme", "wrapperProps"]);

  return createElement(PageContentWrapper, wrapperProps, createElement(PageContent$1, _extends({
    breakpoint: breakpoint,
    isFluid: isFluid || !breakpoint,
    isLayout: isLayout
  }, props, _get(theme, 'fannypack.Page.Content.defaultProps', {})), children));
};
var PageContentPropTypes = _objectSpread({}, containerPropTypes, {
  children: node.isRequired,
  theme: object,
  wrapperProps: object
});
PageContent.propTypes = PageContentPropTypes;
var PageContentDefaultProps = _objectSpread({}, containerDefaultProps, {
  breakpoint: 'tablet',
  isLayout: true,
  theme: {},
  wrapperProps: {}
});
PageContent.defaultProps = PageContentDefaultProps;
var C = withTheme(PageContent);

export default C;
export { PageContent, PageContentDefaultProps, PageContentPropTypes };
